import { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import AceEditor from "react-ace";
import "ace-builds/webpack-resolver"; // Ensure AceEditor is imported correctly
// Import AceEditor modes and themes if not already imported
import "ace-builds/src-noconflict/mode-yaml";
import "ace-builds/src-noconflict/mode-sh";
import "ace-builds/src-noconflict/theme-monokai";
import { AssetDescriptionProps } from "./AssetModelTreeView";
import * as THREE from "three";
import yaml from 'js-yaml';
import { GLTFResult } from "../../api/threed";



export interface AddonDescription {
  position: number[];
  rotation: number[];
  disabled?: boolean;
  type: string;
  sensors: {
    [key: string]: {
      type: string;
      position: number[];
      rotation: number[];
    };
  }
}

export interface AssetManifest {
  techmage: {
    modelPrep: {
      hide?: string[];
      startupAnimations?: string[];
    };
    addons: {
      [key: string]: AddonDescription;
    }
  }
}

export function applyManifestToModel(obj: THREE.Object3D, manifest: string) {
  try {
    const parsed = yaml.load(manifest) as AssetManifest;
    if (!parsed) {
      throw new Error('Invalid manifest');
    }
    const { techmage } = parsed;
    if (!techmage) {
      throw new Error('Invalid manifest, no techmage structure');
    }
    const { modelPrep, addons } = techmage;
    if (modelPrep) {
      const { hide, startupAnimations } = modelPrep;
      if (hide) {
        hide.forEach((name: string) => {
          const object = obj.getObjectByName(name);
          if (object) {
            // console.log(`Hiding object: ${name}`);
            object.visible = false;
          }
        });
      }
      if (startupAnimations) {
        // console.log(`Starting animations: ${startupAnimations.join(', ')}`);
        const gltfAsset = obj.children[obj.children.length - 1];
        // debugger
        const gltf = gltfAsset.userData.gltf as GLTFResult;

        const animations = gltf.animations;
        if (animations) {
          const mixer = new THREE.AnimationMixer(gltfAsset);
          gltfAsset.userData.mixer = mixer;
          mixer.addEventListener("finished", (event) => {
            console.log(`Animation finished: ${event.action}`);
          });
          // debugger
          startupAnimations.forEach((animName: string) => {
            const animation = animations.find((anim: any) => anim.name === animName);
            if (animation) {
              console.log(`Found animation: ${animName}`);
              const action = mixer.clipAction(animation, gltfAsset);
              action.repetitions = 1; // Play once
              action.clampWhenFinished = true; // Stop at the end
              action.reset();
              action.play();
            }
          });
        }
      }
    }
    if (addons) {
      for (const [key, addon] of Object.entries(addons)) {
        addon.position = addon.position || [0, 0, 0];
        addon.rotation = addon.rotation || [0, 0, 0];
        addon.type = addon.type || key;


      }
    }

  } catch (e) {
    console.error('Error parsing manifest:', e);
  }
}

export function AssetManifestEdit({ asset, model, setAsset }: AssetDescriptionProps) {
  const [content, setContent] = useState<string>('');
  const [debounceTimer, setDebounceTimer] = useState<any>(null);
  // const [renderedAddons, setRenderedAddons] = useState<BaseAddon[]>([]);
  useEffect(() => {
    if (!asset) return;
    const manifest = asset.description || '';
    if (manifest) {
      setContent(manifest);
      // if (model) {
      //   for (const addon of renderedAddons) {
      //     addon.remove();
      //   }
      //   setRenderedAddons(applyManifestToModel(model.parent!, manifest));
      // }
    } else {
      setContent('');
    }
  }, [asset, model]);
  useEffect(() => {
    if (!asset) return;
    if (content === asset.description) return;
    if (setAsset) {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
      const timer = setTimeout(() => {
        setAsset({ ...asset, description: content });
        // if (model) {
        //   for (const addon of renderedAddons) {
        //     addon.remove();
        //   }
        //   setRenderedAddons(applyManifestToModel(model.parent!, content));
        // }
      }, 1000);
      setDebounceTimer(timer);
    }
  }, [content]);
  if (!asset) return <Typography variant="h5" >Loading</Typography>;
  return (
    <AceEditor
      mode='yaml'
      theme="twilight"
      fontSize={23}
      width="100%"
      height="800px"
      value={content}
      onChange={setContent}
      editorProps={{ $blockScrolling: true }}
      setOptions={{
        showLineNumbers: true,
        tabSize: 2,
      }}
    />
  );
}
